import { render, staticRenderFns } from "./wx-payment.vue?vue&type=template&id=07c40fa0&scoped=true"
import script from "./wx-payment.vue?vue&type=script&lang=js"
export * from "./wx-payment.vue?vue&type=script&lang=js"
import style0 from "./style/payment.scss?vue&type=style&index=0&id=07c40fa0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c40fa0",
  null
  
)

export default component.exports